import * as React from 'react';

interface SocialSvgProps {
  className?: string;
}

export const X: React.FC<SocialSvgProps> = ({ className }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-platform="x"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231z" />
  </svg>
);
